import uuidv4 from 'uuid/v4';

import { UPDATE_HEADER_TITLE } from 'actions/headers';
import { DROP_FIRST_COLUMN } from 'actions/projects';

const initialState = [
  { id: uuidv4(), title: '' },
  { id: uuidv4(), title: '' },
  { id: uuidv4(), title: '' },
  { id: uuidv4(), title: '' },
];

export default function headersState(state = initialState, action) {
  switch (action.type) {
    case UPDATE_HEADER_TITLE:
      return state.map(h =>
        h.id === action.id ? { ...h, title: action.title } : h,
      );
    case DROP_FIRST_COLUMN:
      return [...state.slice(1), { id: uuidv4(), title: '' }];
    case 'RELOAD_DATA':
      return action.data.headers;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/headers.js